export default function getTimezoneAbbr(timezone?: string): string {
  let abbreviation = '';

  if (timezone) {
    try {
      const winterDate = new Date(Date.UTC(2025, 0, 1, 12, 0)); // Jan 1, 2025 @ noon UTC

      const parts = new Intl.DateTimeFormat(undefined, {
        timeZone: timezone,
        timeZoneName: 'short',
      }).formatToParts(winterDate);

      abbreviation =
        parts.find(part => part.type === 'timeZoneName')?.value ?? '';
    } catch (error) {
      console.warn(
        `Invalid time zone passed to getTimezoneAbbr: ${timezone}`,
        error,
      );
    }
  }

  return abbreviation;
}
